import ClinicalConcernForm from './ClinicalConcernForm';

export default ClinicalConcernForm;
